<template>
  <div id="contenedor-editar-contrato">
    <v-form
      v-model="formularioValido"
      ref="editarContrato">
      <v-row>
        <!-- Generales del contrato -->
        <v-col
          cols="12"
          md="8"
          class="pa-1">
          <v-card
            flat>
            <v-card-text>
              <v-row
                align="center"
                justify="space-between">
                <custom-autocomplete
                  cols="12"
                  md="12"
                  v-model="contrato.idCliente"
                  label="Cliente"
                  :items="mixGetClientes"
                  item-text="nombre"
                  item-value="id"
                  clearable>
                </custom-autocomplete>
                <v-col
                  cols="12"
                  md="4">
                  <v-switch
                    v-model="contrato.esObraFinanciada"
                    inset
                    color="success"
                    label="¿Es obra Financiada?">
                  </v-switch>
                </v-col>
                <custom-text-field
                  cols="12"
                  md="4"
                  v-model="contrato.numero"
                  label="Número"
                  :rules="[mixReglas.requerido]">
                </custom-text-field>
                <custom-autocomplete
                  cols="12"
                  md="4"
                  v-model="contrato.comoSeContrato"
                  label="¿Cómo se Contrató?"
                  :items="tiposContratos"
                  item-text="text"
                  item-value="id"
                  clearable
                  :rules="[mixReglas.requerido]">
                </custom-autocomplete>
                <custom-autocomplete
                  cols="12"
                  md="11"
                  v-model="contrato.idContratista"
                  label="Contratista"
                  :items="contratistas"
                  item-text="nombreRazonSocial"
                  item-value="id"
                  clearable
                  :rules="[mixReglas.requerido]">
                </custom-autocomplete>
                <v-col
                  cols="1">
                  <registrar-nuevo-contratista
                    ref="registrarNuevoContratista"
                    only-icon>
                  </registrar-nuevo-contratista>
                </v-col>
                <custom-text-area
                  cols="12"
                  v-model="contrato.meta"
                  label="Objeto"
                  rows="4"
                  :rules="[mixReglas.requerido]">
                </custom-text-area>
              </v-row>
              <v-row
                justify="space-between">
                <custom-date-picker
                  cols="12"
                  md="4"
                  v-model="contrato.fecha"
                  label="Fecha Contrato"
                  :rules="[mixReglas.requerido]">
                </custom-date-picker>
                <custom-date-picker
                  cols="12"
                  md="4"
                  v-model="contrato.fechaInicio"
                  label="Fecha Inicio"
                  :rules="[mixReglas.requerido]">
                </custom-date-picker>
                <custom-date-picker
                  cols="12"
                  md="4"
                  v-model="contrato.fechaTermino"
                  label="Fecha Termino"
                  :rules="[mixReglas.requerido]">
                </custom-date-picker>
              </v-row>
              <v-row>
                <custom-text-field
                  v-model.number="contrato.plazo"
                  cols="12"
                  md="3"
                  readonly
                  label="Plazo"
                  suffix="días">
                </custom-text-field>
                <custom-text-field
                  cols="12"
                  md="3"
                  v-model.number="contrato.orden"
                  type="number"
                  label="Orden"
                  :rules="[mixReglas.requerido]"
                  required>
                </custom-text-field>
              </v-row>
              <v-divider></v-divider>
              <agregar-obra
                v-if="obras.length <= 0"
                desde-contrato
                :obra="obra">
              </agregar-obra>
              <v-list
                two-line
                dense>
                <v-list-item
                  v-for="(obra, index) in obras"
                  :key="`obra-${obra.id}`">
                  <v-list-item-action>
                    <v-chip>
                      {{ (index + 1) }}
                    </v-chip>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{  obra.obra.clave }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ obra.obra.meta }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <custom-text-field-green
                      :value="obra.importe"
                      label="Importe"
                      prefix="$"
                      readonly
                      es-dinero>
                    </custom-text-field-green>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-row v-if="obras.length > 1">
                <v-col cols="auto" class="py-0">
                  <v-checkbox
                    v-model="contrato.seEjecutaraPorSeparado"
                    hide-details
                    color="secondary"
                    class="my-0">
                    <template v-slot:label>
                      <span class="secondary--text">Ejecutar por separado</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-divider class="mt-2"></v-divider>
              <!-- Sancion y Retencion -->
                <v-row>
                  <v-col>
                    <v-row justify="center">
                      <h3 class="base6--text">Sanción</h3>
                    </v-row>
                    <v-row justify="space-between" align="center">
                      <v-radio-group
                        cols="8"
                        v-model="contrato.periodicidadSancion"
                        label="Periodicidad de sanción"
                        mandatory
                      >
                        <v-radio value="diaria">
                          <template v-slot:label>
                            <div>
                              <strong class="secondary--text">Diaria</strong>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="mensual">
                          <template v-slot:label>
                            <div>
                              <strong class="secondary--text">Mensual</strong>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                      <custom-text-field
                        cols="4"
                        v-model.number="contrato.porcentajeSancion"
                        label="% Sanción"
                      >
                      </custom-text-field>
                    </v-row>
                  </v-col>
                  <v-divider vertical></v-divider>
                  <v-col>
                    <v-row justify="center">
                      <h3 class="base6--text">Retención</h3>
                    </v-row>
                    <v-row justify="space-between" align="center">
                      <v-radio-group
                        cols="8"
                        v-model="contrato.tipoRetencion"
                        label="Tipo de Retención"
                        mandatory
                      >
                        <v-radio value="baseDias">
                          <template v-slot:label>
                            <div>
                              <strong class="secondary--text"
                                >Por días de atraso</strong
                              >
                            </div>
                            <div class="d-block">
                              <v-switch
                                v-model="contrato.redondearMasDiasEjecutados"
                                label="Redondear hacia arriba"
                                :disabled="contrato.tipoRetencion === 'baseMonto'"
                                hide-details>
                              </v-switch>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="baseMonto">
                          <template v-slot:label>
                            <div>
                              <strong class="secondary--text"
                                >Por monto de atraso</strong
                              >
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                      <v-row>
                        <custom-text-field
                          cols="6"
                          v-model.number="contrato.porcentajeRetencion"
                          label="% Retención"
                        >
                        </custom-text-field>
                        <v-col>
                          <v-switch
                            v-model="contrato.esRetencionPorDia"
                            label="Por Día"
                            :disabled="contrato.tipoRetencion === 'baseMonto'"
                            hide-details>
                          </v-switch>
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-col>
                </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Monto del contrato -->
        <v-col
          cols="12"
          md="4"
          class="pa-1">
          <v-card
            dense>
            <v-card-title
              class="base6--text">
              Monto del contrato
            </v-card-title>
            <v-card-text>
              <v-row>
                <template
                  v-if="contrato.esObraFinanciada">
                  <custom-text-field-green
                    cols="12"
                    v-model.number="contrato.importeCostoDirecto"
                    label="Importe Costo Directo"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada">
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="5"
                    v-model.number="contrato.porcentajeCostoIndirectos"
                    label="% Indirectos"
                    :rules="[mixReglas.requerido]">
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="7"
                    v-model.number="contrato.importeCostoIndirectos"
                    label="Importe Indirectos"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada">
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="5"
                    v-model.number="contrato.porcentajeUtilidad"
                    label="% Utilidad"
                    :rules="[mixReglas.requerido]">
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="7"
                    v-model.number="contrato.importeUtilidad"
                    label="Importe Utilidad"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada">
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="5"
                    v-model.number="contrato.porcentajeCargosAdicionales"
                    label="% Adicionales"
                    :rules="[mixReglas.requerido]">
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="7"
                    v-model.number="contrato.importeCargosAdicionales"
                    label="Importe Adicionales"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada">
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="5"
                    v-model.number="contrato.porcentajeCostoFinanciero"
                    label="% C. Financiero"
                    :rules="[mixReglas.requerido]">
                  </custom-text-field-green>
                  <custom-text-field-green
                    cols="7"
                    v-model.number="contrato.importeCostoFinanciero"
                    label="Importe C. Financiero"
                    es-dinero
                    prefix="$"
                    :rules="[mixReglas.requerido]"
                    @keyup="sumarImportesObrasFinanciada">
                  </custom-text-field-green>
                  <v-col
                    cols="12">
                    <v-divider></v-divider>
                  </v-col>
                </template>
                <custom-text-field-green
                  cols="12"
                  v-model.number="contrato.importe"
                  label="Importe"
                  es-dinero
                  prefix="$"
                  :rules="[mixReglas.requerido, reglas.mayorCero]"
                  @keyup="calcularTotal">
                </custom-text-field-green>
                <custom-text-field-green
                  cols="12"
                  md="4"
                  v-model.number="contrato.porcentajeIva"
                  label="% I.V.A."
                  suffix="%"
                  es-dinero
                  :rules="[mixReglas.requerido]"
                  @keyup="calcularTotal">
                </custom-text-field-green>
                <custom-text-field-green
                  cols="12"
                  md="8"
                  v-model="contrato.iva"
                  label="Importe I.V.A."
                  prefix="$"
                  es-dinero
                  readonly
                  disabled>
                </custom-text-field-green>
                <custom-text-field-green
                  cols="12"
                  v-model="contrato.total"
                  es-dinero
                  label="Total"
                  prefix="$"
                  readonly
                  disabled>
                </custom-text-field-green>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import mixContratos from './mixContratos';
import RegistrarNuevoContratista from '@/components/administracion/configuracion/catalogos/contratistas/Nuevo.vue';
import AgregarObra from '@/components/administracion/obras/basico/Nueva.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';

export default {
  name: 'RegistrarNuevoContrato',
  mixins: [mixContratos],
  props: {
    contratoEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    RegistrarNuevoContratista,
    AgregarObra,
    CustomAutocomplete,
    // CustomSelect,
    CustomTextField,
    CustomTextFieldGreen,
    CustomTextArea,
    CustomDatePicker,
    // ObrasPicker,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoContratista: false,
      contratistaSelected: null,
      formularioValido: false,
      enviandoFormulario: false,
      reglas: {
        mayorCero: (val) => {
          const valor = Number(String(val).replace(/\D/g, ''));
          return valor > 0 || 'El monto debe de ser mayor a 0.';
        },
      },
      contrato: {
        idContratista: this.contratoEditar.idContratista, // ! String
        idCliente: this.contratoEditar.idCliente, // ! String
        seEjecutaraPorSeparado: this.contratoEditar.seEjecutaraPorSeparado, // Boolean
        esObraFinanciada: this.contratoEditar.esObraFinanciada,
        comoSeContrato: this.contratoEditar.comoSeContrato, // ! String
        numero: this.contratoEditar.numero, // ! String
        ejercicio: this.contratoEditar.ejercicio, // ! Int
        fecha: this.contratoEditar.fecha, // ! String
        meta: this.contratoEditar.meta, // ! String
        importeCostoDirecto: this.contratoEditar.importeCostoDirecto,
        porcentajeCostoIndirectos: this.contratoEditar.porcentajeCostoIndirectos,
        importeCostoIndirectos: this.contratoEditar.importeCostoIndirectos,
        porcentajeUtilidad: this.contratoEditar.porcentajeUtilidad,
        importeUtilidad: this.contratoEditar.importeUtilidad,
        porcentajeCargosAdicionales: this.contratoEditar.porcentajeCargosAdicionales,
        importeCargosAdicionales: this.contratoEditar.importeCargosAdicionales,
        porcentajeCostoFinanciero: this.contratoEditar.porcentajeCostoFinanciero,
        importeCostoFinanciero: this.contratoEditar.importeCostoFinanciero,
        importe: this.contratoEditar.importe, // ! Double
        porcentajeIva: this.contratoEditar.porcentajeIva, // ! Int
        iva: this.contratoEditar.iva, // ! Double
        total: this.contratoEditar.total, // ! Double
        fechaInicio: this.contratoEditar.fechaInicio, // ! String
        fechaTermino: this.contratoEditar.fechaTermino, // ! String
        plazo: this.contratoEditar.plazo, // ! Int
        periodicidadSancion: this.contratoEditar.periodicidadSancion, // ! String
        porcentajeSancion: this.contratoEditar.porcentajeSancion, // ! Double
        tipoRetencion: this.contratoEditar.tipoRetencion, // ! String
        porcentajeRetencion: this.contratoEditar.porcentajeRetencion, // ! Double
        esRetencionPorDia: this.contratoEditar.esRetencionPorDia,
        redondearMasDiasEjecutados: this.contratoEditar.redondearMasDiasEjecutados,
        normatividad: this.contratoEditar.normatividad, // ! Int
        orden: this.contratoEditar.orden,
        obras: [],
      },
      obra: {
        idPrograma: '', // (Catalogo)
        idTipo: '', // (Catalogo)
        idSubtipo: '', // (Catalogo)
        ejercicio: 0,
        clave: '',
        meta: '',
        ubicacion: {
          idMunicipio: '', // (Catalogo)
          ubicacion: '',
          localidad: '',
          cabeceraMunicipial: false,
        },
        impacto: {
          beneficiados: 0,
          metaFisica: 0,
          metaFisicaUnidad: '',
          justificacionTecnica: '',
          justificacionSocial: '',
          problematica: '',
          avanceFisicoActual: 0, // Float
          avanceProgramadoCierre: 0, // Float
          descripcionTotalObra: '',
          conceptosEjecutar: '',
        },
      },
      obras: this.contratoEditar.obras,
      tiposContratos: [
        { id: 'LP', text: 'LICITACIÓN PÚBLICA' },
        { id: 'LI', text: 'LICITACIÓN RESTINGIDA POR INVITACIÓN' },
        { id: 'AD', text: 'ADJUDICACION DIRECTA' },
      ],
      ejercicios: [],
    };
  },
  mounted() {
    this.fetch(this.contratoEditar);
    this.obra.clave = this.contratoEditar.numero;
    this.obra.ejercicio = this.contratoEditar.ejercicio;
    this.obra.meta = this.contratoEditar.meta;
  },
  methods: {
    fetch(contrato) {
      this.contrato.idContratista = contrato.idContratista;
      this.contrato.seEjecutaraPorSeparado = contrato.seEjecutaraPorSeparado;
      this.contrato.esObraFinanciada = contrato.esObraFinanciada;
      this.contrato.comoSeContrato = contrato.comoSeContrato;
      this.contrato.numero = contrato.numero;
      this.contrato.ejercicio = contrato.ejercicio;
      this.contrato.fecha = contrato.fecha;
      this.contrato.meta = contrato.meta;
      this.contrato.importeCostoDirecto = contrato.importeCostoDirecto;
      this.contrato.porcentajeCostoIndirectos = contrato.porcentajeCostoIndirectos;
      this.contrato.importeCostoIndirectos = contrato.importeCostoIndirectos;
      this.contrato.porcentajeUtilidad = contrato.porcentajeUtilidad;
      this.contrato.importeUtilidad = contrato.importeUtilidad;
      this.contrato.porcentajeCargosAdicionales = contrato.porcentajeCargosAdicionales;
      this.contrato.importeCargosAdicionales = contrato.importeCargosAdicionales;
      this.contrato.porcentajeCostoFinanciero = contrato.porcentajeCostoFinanciero;
      this.contrato.importeCostoFinanciero = contrato.importeCostoFinanciero;
      this.contrato.importe = contrato.importe;
      this.contrato.porcentajeIva = contrato.porcentajeIva;
      this.contrato.iva = contrato.iva;
      this.contrato.total = contrato.total;
      this.contrato.fechaInicio = contrato.fechaInicio;
      this.contrato.fechaTermino = contrato.fechaTermino;
      this.contrato.plazo = contrato.plazo;
      this.contrato.periodicidadSancion = contrato.periodicidadSancion;
      this.contrato.porcentajeSancion = contrato.porcentajeSancion;
      this.contrato.normatividad = contrato.normatividad;
      this.contrato.orden = contrato.orden;
    },
    limpiarFormulario() {
      this.$refs.editarContrato.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  computed: {
    fechaInicio() {
      return this.contrato.fechaInicio;
    },
    fechaTermino() {
      return this.contrato.fechaTermino;
    },
  },
  watch: {
    contratoEditar: {
      handler(contrato) {
        this.fetch(contrato);
        this.obra.clave = contrato.numero;
        this.obra.ejercicio = contrato.ejercicio;
        this.obra.meta = contrato.meta;
      },
    },
    contrato: {
      handler(contrato) {
        this.obra.clave = contrato.numero;
        this.obra.ejercicio = contrato.ejercicio;
        this.obra.meta = contrato.meta;
      },
      deep: true,
    },
    formularioValido: {
      handler(valor) {
        this.$emit('formularioValido', valor);
      },
    },
    enviandoFormulario: {
      handler(valor) {
        this.$emit('enviandoFormulario', valor);
      },
    },
    fechaInicio() {
      this.setPlazo();
    },
    fechaTermino() {
      this.setPlazo();
    },
    'contrato.importe': {
      handler() {
        this.calcularTotal();
      },
    },
  },
};
</script>

<style lang="scss">

</style>
